import { useAuth } from "@/context/AuthContext";
import { ShieldCheck } from "lucide-react";
import { DonkeyAvatar } from "@/components/DonkeyMascot";
import DonkeyBotChat from "@/components/DonkeyBotChat";

export default function DonkeyBot() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-donkey-bg grain text-donkey-warm">
      <div className="mx-auto max-w-2xl px-5 sm:px-8 py-10">
        <div className="flex items-center gap-3 mb-1"><DonkeyAvatar size={52} /><h1 className="font-heading font-extrabold text-3xl">DonkeyBot</h1></div>
        <p className="text-sm text-donkey-grey mb-4 flex items-center gap-1.5"><ShieldCheck className="w-4 h-4" /> Automated support guide{user ? " · AI enabled on your plan" : " · sign in for AI help"}. Not a substitute for human support or emergencies.</p>
        <DonkeyBotChat />
      </div>
    </div>
  );
}
